import { THEME } from 'components/theme'
// Theme tokens so the card reads the same in light and dark (the old peach / fixed greys went
// muddy under the dark-mode colour mapping)
const GREEN = THEME.brandGreen
const WHITE = THEME.brandWhite
const DISC = THEME.brandLightGreen
const GREY_900 = THEME.brandBlack
const GREY_700 = THEME.brandDarkerGrey

const GoogleDriveRequiredDialogStyles = {
  backdrop: {
    position: 'fixed' as const,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(68, 68, 68, 0.72)',
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    zIndex: 1000,
    padding: '16px',
    boxSizing: 'border-box' as const
  },
  card: {
    background: WHITE,
    borderRadius: '12px',
    padding: '24px 20px 20px',
    width: '320px',
    maxWidth: 'calc(100vw - 32px)',
    boxSizing: 'border-box' as const,
    position: 'relative' as const,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center' as const,
    gap: '12px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.15)'
  },
  closeButton: {
    position: 'absolute' as const,
    top: '12px',
    right: '12px',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '50%',
    '&:hover': {
      background: THEME.brandGrey
    },
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    color: GREY_700
  },
  iconCircle: {
    width: '72px',
    height: '72px',
    borderRadius: '50%',
    background: DISC,
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    marginTop: '8px'
  },
  title: {
    fontSize: '20px',
    fontWeight: 700,
    color: GREY_900,
    margin: 0,
    width: '100%',
    textAlign: 'center' as const
  },
  body: {
    fontSize: '14px',
    color: GREY_900,
    margin: 0,
    width: '100%',
    textAlign: 'center' as const,
    lineHeight: '20px'
  },
  primaryButton: {
    width: '100%',
    padding: '14px 16px',
    borderRadius: '999px',
    border: 'none',
    background: GREEN,
    color: WHITE,
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center' as const,
    justifyContent: 'center' as const,
    gap: '8px',
    marginTop: '4px'
  },
  driveLogo: {
    width: '18px',
    height: '18px',
    flexShrink: 0
  }
}

export default GoogleDriveRequiredDialogStyles
